import { render, staticRenderFns } from "./AltaTecnicoBase.vue?vue&type=template&id=fc9499c8&"
import script from "./AltaTecnicoBase.vue?vue&type=script&lang=ts&"
export * from "./AltaTecnicoBase.vue?vue&type=script&lang=ts&"
import style0 from "./AltaTecnicoBase.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports